import React from 'react';
import './footer.css';

import { FaFacebookF, FaGlobe, FaInstagram, FaHeart } from 'react-icons/fa';
import { IoLocationSharp, IoMailSharp } from 'react-icons/io5';
import { IoMdCall } from 'react-icons/io';

import LOGO from '../../img/logo-min.png';

const Footer = () => {
    const year = new Date();

    const script = document.createElement('script');

    script.src =
        'https://counter9.stat.ovh/private/counter.js?c=mnpzetk7kka3qbpq1614ws6cm5dtrl6k&down=async';
    script.async = true;

    document.body.appendChild(script);

    return (
        <div className="footer-dark">
            <footer>
                <div className="counter">
                    <small className="counter-text">Contador de visitas:</small>
                    <div
                        id="sfcmnpzetk7kka3qbpq1614ws6cm5dtrl6k"
                        className="counter-value"
                    ></div>
                </div>
                <hr className="separator-decorator" />
                <div className="container px-3 pt-2">
                    <div className="row">
                        <div className="col-md-10 text-center item text mx-auto">
                            <img
                                src={LOGO}
                                alt="Dirección Municipal de Turismo y Cultura Tarija"
                                className="logo pb-4"
                            ></img>
                            <div>
                                <h3>
                                    Dirección Municipal de Turismo y Cultura
                                </h3>
                                <h3>Unidad de Cultura</h3>
                            </div>
                        </div>
                    </div>
                    <div className="row item text text-center">
                        <div className="col-lg-4 col-md-12 text-contact">
                            <p>
                                <IoLocationSharp className="icon-contact" />
                                General Trigo entre 15 de abril y Virginio Lema
                            </p>
                        </div>
                        <div className="col-lg-4 col-md-12 text-contact">
                            <p>
                                <IoMailSharp className="icon-contact" />
                                turismocultura@hotmail.com
                            </p>
                            <p>
                                <IoMailSharp className="icon-contact" />
                                turismoyculturatarija@gmail.com
                            </p>
                            <p>
                                <IoMailSharp className="icon-contact" />
                                direccion.turismoycultura@tarija.bo
                            </p>
                        </div>
                        <div className="col-lg-4 col-md-12 text-contact">
                            <p>
                                <IoMdCall className="icon-contact" />
                                +591 4-6110985
                            </p>
                        </div>
                    </div>
                    <hr className="separator-decorator" />
                    <div className="row pt-3">
                        <div className="col-12 item social">
                            <a
                                href="https://www.facebook.com/turismoyculturatarija"
                                target="_blank"
                                rel="noreferrer"
                                title="Síguenos en Facebook"
                            >
                                <FaFacebookF className="icon-footer" />
                            </a>
                            <a
                                href="https://www.instagram.com/gob_municipal_tarija/"
                                target="_blank"
                                rel="noreferrer"
                                title="Encuéntranos en Instagram"
                            >
                                <FaInstagram className="icon-footer" />
                            </a>
                            <a
                                href="https://www.tarijaturismo.com/"
                                target="_blank"
                                rel="noreferrer"
                                title="Sitio Web Oficial"
                            >
                                <FaGlobe className="icon-footer" />
                            </a>
                        </div>
                    </div>
                    <p className="copyright">
                        <span className="copyright-text">
                            © Copyright {year.getFullYear()}{' '}
                        </span>
                        <a
                            href="https://www.tarijaturismo.com/"
                            target="_blank"
                            rel="noreferrer"
                            title="Sitio Web Oficial"
                            className="copy-link"
                        >
                            Dirección Municipal de Turismo y Cultura Tarija
                        </a>
                        <span className="copyright-text">
                            {' '}
                            - Todos los derechos reservados
                        </span>
                    </p>
                    <p className="copyright pt-0 pb-4">
                        <span className="copyright-text">
                            Desarrollado con
                            <FaHeart className="icon-heart mx-1" />
                            por{' '}
                        </span>
                        <a
                            href="https://miguelangelchoqueramirez.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                            title="Portafolio"
                            className="copy-link"
                        >
                            Miguel Ángel Choque Ramírez
                        </a>
                    </p>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
